import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const imageProng = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.914,
  type: 'Image191x100',
  associationType: 'LandscapeImageMedia',
  stringKey: 'ImageExperience_Image_Ratio_191x100',
  imagePreviewHeight: 140,
  simplifiedType: 'Image191x100',
  className: 'boost-191X1',
  isRequired: true,
  minimumRequirements: 1,
  minSize: [268, 140],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Prong 1 / Prong 2 / Feed'),
    stringKey: _TL_('Prong 1 / Prong 2 / Feed'),
  },
  previewSettings: {
    previewContentClassName: 'boost-191X1',
    showBusinessName: true,
    showLongHeadline: true,
    multipleLineLongHeadline: true,
    hideLabel: true,
    showImage: true,
  },
  styleOverrides: {
    cardParent: {
      borderRadius: 8,
      '& .responsive-ad-preview-content': {
        width: '268px !important',
        height: '270px !important',
        background: '#262632 !important',
      },
      '& .image-container': {
        position: 'absolute',
        width: '100%',
        height: 140,
        top: 0,
      },
      '& .long-headline': {
        position: 'absolute',
        width: 250,
        fontSize: 18,
        left: 20,
        top: 180,
        color: 'white',
        fontWeight: 600,
      },
      '& .business-name-with-ads': {
        position: 'absolute',
        top: 140,
        left: 20,
        color: 'white',
      },
    },
  },
};

export default imageProng;

